import { pctFmt } from './shared/formatters'
import { summarizeRaw, formatSummary } from './shared/periods'

export const asRevealed = (row) => ({ ...row, subRow: true, justRevealed: true });

export const buildPlaceholderRow = (monthKeys, summaryPeriods) => ({
  values: monthKeys.map(() => "—"),
  semesterValuesSummary: summaryPeriods.map(() => "—"),
  placeholder: true,
});

export const buildHybridAdditiveRow = ({ monthKeys, hybridAgg, field, fmt, summaryPeriods }) => {
  const rawValues = monthKeys.map((_, i) => hybridAgg[i]?.[`_${field}`] ?? null);

  const values = rawValues.map(v => v != null ? fmt(v) : null);
  const semRawValues = summarizeRaw(rawValues, summaryPeriods);

  return {
    values,
    rawValues,
    semesterValuesSummary: formatSummary(semRawValues, fmt),
    semRawValues,
  };
};

export const buildHybridDisplayRow = ({ monthKeys, hybridAgg, field, rawField }) => {
  const key = rawField ?? field;

  return {
    values: monthKeys.map((_, i) => hybridAgg[i]?.[field] ?? null),
    rawValues: monthKeys.map((_, i) => hybridAgg[i]?.[`_${key}`] ?? null),
  };
};

export const buildMarkdownRow = ({ monthKeys, hybridAgg, summaryPeriods }) => {
  const monthlyRow = buildHybridDisplayRow({ monthKeys, hybridAgg, field: 'markdownPercent' });

  const bases = monthKeys.map((_, i) => {
    const source = hybridAgg[i];

    const units = source?._unitsSold;
    const originalPrice = source?._originalPrice;
    const salePrice = source?._salePrice;

    if (units == null || originalPrice == null || salePrice == null) return null;

    return { original: originalPrice * units, sale: salePrice * units };
  });

  const rawValues = summaryPeriods.map(({ monthIndexes }) => {
    let original = 0;
    let sale = 0;
    let hasData = false;

    for (const i of monthIndexes) {
      if (!bases[i]) continue;
      original += bases[i].original;
      sale += bases[i].sale;
      hasData = true;
    }

    if (!hasData || sale <= 0) return null;

    const markdown = original / sale - 1;
    return markdown > 0 ? markdown : null;
  });

  return {
    ...monthlyRow,
    semesterValuesSummary: rawValues.map(value => value != null ? pctFmt.format(value) : null),
    semRawValues: rawValues,
  };
};